import * as React from 'react';

import routes from 'defs/routes';
import i18n from 'helper/i18n';
import noop from 'helper/noop';

import Knob from 'components/atoms/Knob';
import OnboardingStep from 'components/molecules/Onboarding/Step';
import Overlay from 'components/molecules/Overlay';
import Slider, { Slide } from 'components/molecules/Slider';

type OnboardingProps = {
	visible?: boolean;
	delegate: Function;
};

export default class Onboarding extends React.Component<OnboardingProps> {
	public static displayName = 'Onboarding(Standalone)';
	public static defaultProps = {
		delegate: noop,
		visible: true,
	};

	public onCloseHandler = () => {
		this.props.delegate();
	};

	public render() {
		return (
			<Overlay
				id="m-overlay-onboarding--standalone"
				contentStyle="onboarding"
				isOpen={!!this.props.visible}
				closable
			>
				<div className="m-onboarding m-onboarding--standalone" data-standalone>
					<Slider
						modifier="onboarding"
						decorator="Onboarding"
						nextText={i18n('react.impulsCoach.components.onboarding.step.nextStepCaption')}
					>
						<Slide key={1}>
							<OnboardingStep
								coach="MIA"
								image="step-1"
								title={i18n('react.impulsCoach.components.onboarding.step1.title')}
								text={i18n('react.impulsCoach.components.onboarding.step1.text')}
							/>
						</Slide>
						<Slide key={2}>
							<OnboardingStep
								coach="LEO"
								modifier="2"
								image="step-2"
								title={i18n('react.impulsCoach.components.onboarding.step2.title')}
								text={i18n('react.impulsCoach.components.onboarding.step2.text')}
							/>
						</Slide>
						<Slide key={3}>
							<OnboardingStep
								count={3}
								modifier="3"
								icon="calendar-day"
								title={i18n('react.impulsCoach.components.onboarding.step3.title')}
								text={i18n('react.impulsCoach.components.onboarding.step3.text')}
							/>
						</Slide>
						<Slide key={4}>
							<OnboardingStep
								modifier="4"
								image="step-4"
								isLastStep
								// tslint:disable-next-line: jsx-no-bind
								onFinishClick={this.onCloseHandler}
								redirectUrl={routes.dashboard.indexRoute.href}
								title={i18n('react.impulsCoach.components.onboarding.step4.title')}
								text={i18n('react.impulsCoach.components.onboarding.step4.text')}
							/>
						</Slide>
					</Slider>
					<div className="m-onboarding__close">
						{/* // tslint:disable-next-line: jsx-no-bind */}
						<Knob size="s" icon="close" onClick={this.onCloseHandler} />
					</div>
				</div>
			</Overlay>
		);
	}
}
